import { Box, Skeleton } from '@mui/material'

const ImportSkeleton = () => (
  <Box sx={{ overflow: 'hidden', border: '1px solid #EFEFEF', borderRadius: 1 }}>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '35% 1fr',
        gap: 2,
        alignItems: 'center',
        minHeight: 32,
        padding: '0 12px',
        borderBottom: '1px solid #EFEFEF',
        backgroundColor: '#F7F7F7'
      }}>
      <Skeleton variant="text" width={56} height={16} animation="wave" />
      <Skeleton variant="text" width={88} height={16} animation="wave" />
    </Box>
    {Array.from({ length: 4 }, (_, index) => (
      <Box
        key={index}
        sx={{
          display: 'grid',
          gridTemplateColumns: '35% 1fr',
          gap: 2,
          alignItems: 'center',
          minHeight: 40,
          padding: '0 12px',
          borderBottom: index === 3 ? 'none' : '1px solid #F7F7F7'
        }}>
        <Skeleton variant="text" width={`${72 - index * 6}%`} height={18} animation="wave" />
        <Skeleton variant="text" width={`${88 - index * 9}%`} height={18} animation="wave" />
      </Box>
    ))}
  </Box>
)

export default ImportSkeleton
